import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const detalleError = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  return typeof detail === "string" ? detail : fallback;
};
